<div class="codex-indicator-main-container">
    <div class="carousel-container">
        <div class="carousel-btn-container"
            (click)="prevCarouselPage()">
            <div class="previous-button carousel-btn">
                <i class="bi bi-chevron-left"></i>
            </div>
            <span>{{'drill_down_previous_button' | translate}}</span>
        </div>
        <p-carousel
            *ngIf="currentReport.details.length"
            #carousel
            [value]="currentReport.details"
            [page]="currentPage"
            [numVisible]="1"
            [numScroll]="1"
            [showIndicators]="false"
            [showNavigators]="false"
            (onPage)="changeIndicator($event)">
            <ng-template pTemplate="item" let-item let-index="index">
                <div class="category-carousel-main-item-container">
                    <div class="category-carousel-item">
                        <div class="category-icon-container" [ngStyle]="{'background-image':item.indicatorViewGradientColor}">
                            <img [src]="'../../../assets/icons/codex/'+item.category.slug+'.svg'">
                        </div>
                        <span class="category-name">{{item.category.title}}</span>
                        <div class="category-value-container">
                            <span class="category-value">{{item.indicatorViewScore}}</span>
                            <span class="category-percentage">%</span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
        <div class="carousel-btn-container"
            (click)="nextCarouselPage()">
            <span>{{'drill_down_next_button' | translate}}</span>
            <div class="next-button carousel-btn">
                <i class="bi bi-chevron-right"></i>
            </div>
        </div>
    </div>
    <h1>Statements</h1>
    <div class="quarter-table-container">
        <p-table [value]="codexesByCategory" responsiveLayout="scroll">
            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="width:7%">
                    <col style="width:30%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:9%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:8%">
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">QUARTER</div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">STATEMENT</div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option1' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option2' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option3' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'middle' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option5' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option6' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div class="quarter-table-cell quarter-header-cell">
                            {{ 'tryit_option7' | translate | uppercase }}
                        </div>
                    </th>
                    <th>
                        <div #origin6="cdkOverlayOrigin" cdkOverlayOrigin class="quarter-table-cell quarter-header-cell d-flex gap-2 align-items-center justify-content-center">
                            SCORE
                            <i class="bi bi-filter sorting-icon icon-flex-alignment" 
                                [ngClass]="{'show-badge' : hasActiveSort('average_score')}"
                                (click)="openSortMenu('average_score')"
                                pBadge badgeDot severity="info">
                            </i>
                            <ng-template
                                cdkConnectedOverlay
                                [cdkConnectedOverlayOrigin]="origin6"
                                [cdkConnectedOverlayOpen]="activeMenuCategory === 'average_score'"
                                (backdropClick)="activeMenuCategory = null"
                                [cdkConnectedOverlayHasBackdrop]="true"
                                cdkConnectedOverlayBackdropClass="transparent-backdrop">
                                <div class="sorting-main-container">
                                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                                    <input
                                        class="sorting-checkbox"
                                        type="checkbox"
                                        [checked]="isChecked('average_score', 'ASC')"
                                        (change)="toggleSort('average_score', 'ASC')">
                                    <span style="font-size: 1.4rem;">Ascending</span>
                                    </label>
                                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                                    <input
                                        class="sorting-checkbox"
                                        type="checkbox"
                                        [checked]="isChecked('average_score', 'DESC')"
                                        (change)="toggleSort('average_score', 'DESC')">
                                    <span style="font-size: 1.4rem;">Descending</span>
                                    </label>
                                </div>
                            </ng-template>
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-indicator>
                <tr>
                    <td>
                        <div class="d-flex flex-column align-items-center justify-content-center quarter-table-cell">
                            <span class="text-center fw-bold">{{indicator.codex.slice(0, 3)}}</span>
                            <span class="text-center">{{indicator.codex.slice(3, indicator.codex.length)}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="quarter-table-cell">
                            {{indicator.question}}
                        </div>
                    </td>
                    <td *ngFor="let questionCategory of indicator.details">
                        <div [ngClass]="{'bold-box' : questionCategory.isHighest}" class="d-flex align-items-center justify-content-center quarter-table-cell">
                            {{questionCategory.percentage+'%'}}
                        </div>
                    </td>
                    <td>
                        <div [ngStyle]="{'background-color': indicator.fadeColor}" class="d-flex align-items-center justify-content-center fw-bold quarter-table-cell">
                            {{indicator.score+'%'}}
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>